export default __webpack_public_path__ + "static/placeholder-8a0700783e429660d1fee117bd4bf9a2.jpg";